import React, { useEffect, useState } from "react";
import "./AssignSection.scss";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { adminRequest } from "../../../utils/requestMethods";
import { BASE_URL } from "../../../utils/config";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

const AssignSection = () => {
  const initialFormData = {
    course: "",
    semester_id: "",
    sectionIds: [],
  };

  const [formData, setFormData] = useState(initialFormData);
  const [semester, setSemester] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [courses, setCourses] = useState([]);
  const [sections, setSections] = useState([]);

  const navigate = useNavigate();
  const handleBackClick = () => {
    navigate(-1);
  };

  useEffect(() => {
    const fetchProgram = async () => {
      try {
        const response = await adminRequest.get(
          `${BASE_URL}/course/getNameAndId`,
        );
        setCourses(response.data.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchProgram();
  }, []);

  useEffect(() => {
    if (formData.course) {
      const fetchSemester = async () => {
        try {
          const response = await adminRequest.post(
            `${BASE_URL}/course/getSemestersById`,
            { id: formData.course },
          );
          setSemester(response.data.data);
        } catch (error) {
          console.log(error);
        }
      };
      fetchSemester();
    }
  }, [formData.course]);

  useEffect(() => {
    if (formData.semester_id) {
      const fetchSection = async () => {
        try {
          const response = await adminRequest.get(
            `${BASE_URL}/section/list/active`,
          );
          setSections(response.data.data);
        } catch (error) {
          console.log(error);
        }
      };
      fetchSection();
    }
  }, [formData.semester_id]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      sectionIds: checked
        ? [...prevData.sectionIds, Number(value)]
        : prevData.sectionIds.filter((id) => id !== Number(value)),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await toast.promise(
        adminRequest.post(`${BASE_URL}/section/assign`, {
          courseId: formData.course,
          curriculumId: formData.semester_id,
          sectionIds: formData.sectionIds,
        }),
        {
          pending: "Processing your request",
        },
      );

      toast.success(response.data?.message);
      setFormData(initialFormData);
    } catch (error) {
      toast.error(error.response.data?.message);
      console.log(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="assignSectionContainer">
      <div className="top">
        <span className="backIcon" onClick={handleBackClick}>
          <FaArrowLeftLong />
        </span>
        <span className="headerTitle">Assign Section to Semester</span>
      </div>
      <div className="bottom">
        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <div className="courseWrapper">
            <div className="inputGroup">
              <label htmlFor="courses">Course</label>
              <select
                name="course"
                value={formData.course}
                onChange={handleChange}
              >
                <option value="" disabled>
                  Select Course
                </option>
                {courses.map((option, index) => (
                  <option value={option.id} key={index}>
                    {option.short_name}
                  </option>
                ))}
              </select>
            </div>
            <div className="inputGroup">
              <label htmlFor="semester">Semester</label>
              <select
                name="semester_id"
                value={formData.semester_id}
                onChange={handleChange}
              >
                <option value="" disabled>
                  Select Semester
                </option>
                {semester.map((option, index) => (
                  <option value={option.id} key={index}>
                    {option.semester}
                  </option>
                ))}
              </select>
            </div>
            <div className="inputGroup">
              <label>Select Sections</label>
              <div className="checkboxGroup">
                {sections.map((option, index) => (
                  <label key={option.uuid} className="checkboxLabel">
                    <input
                      type="checkbox"
                      name="section_id"
                      value={option.id}
                      checked={formData.sectionIds.includes(option.id)}
                      onChange={handleCheckboxChange}
                    />
                    {option.name}
                  </label>
                ))}
              </div>
            </div>
          </div>
        </form>
        <div className="submitWrapper">
          <button
            type="submit"
            className="create-btn"
            onClick={handleSubmit}
            disabled={isSubmitting}
          >
            Assign
          </button>
          <button
            type="submit"
            className="cancel-btn "
            onClick={handleBackClick}
          >
            Cancel
          </button>
        </div>
      </div>
      <ToastContainer position="top-center" />
    </div>
  );
};

export default AssignSection;
